import { SearchRepository } from './repositories/search'
import { SearchService } from './services/search'

const searchRepository = new SearchRepository()

const searchService = new SearchService({
    searchRepository,
})

export { searchService }
